import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SaidaAutenticacao } from '@models/Autenticacao/SaidaAutenticacao.model';
import { ContaService } from '@services/conta.service';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthAdminGuard implements CanActivate {

  subscriptionLogin: Subscription;

  constructor(private _contaService: ContaService, private router: Router) {
    this.subscriptionLogin = _contaService._eventoLogin.subscribe(x => {
      this.dataRequisicaoAnterior = new Date();
    });
  }

  dataRequisicaoAnterior: Date = new Date();
  funcaoSomarMinutos = (data: Date, numeroMinutos): Date => {
    var dataHoraMais30 = new Date(data.getTime() + (numeroMinutos * 60 * 1000));
    return dataHoraMais30;
  }

  valorEmMinutosPredefinidoAqui: number = (30 * 24 * 60) - 5;//29.8;
  public funcaoSolicitarExtensaoSessao = () => {
    this.dataRequisicaoAnterior = new Date();
  }

  public funcaoObterDataRequisicaoAnterior = (): Date => {
    var dataHoraFinalSessao = new Date(this.dataRequisicaoAnterior.getTime() + (this.valorEmMinutosPredefinidoAqui * 60 * 1000));
    return dataHoraFinalSessao;
  }

  public funcaoObterDataAviso = (): Date => {
    var dataHoraAviso = new Date(new Date().getTime() + ((this.valorEmMinutosPredefinidoAqui - 25) * 60 * 1000));
    return dataHoraAviso;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
    if (new Date() < this.funcaoSomarMinutos(this.dataRequisicaoAnterior, this.valorEmMinutosPredefinidoAqui)) {
      this.dataRequisicaoAnterior = new Date();
    }
    else {
      //this.router.navigate(['/conta/login']);
      //return false;
    }

    var informacoesAutenticacao = this._contaService.funcaoObterInformacoesAutenticacao();
    var listaModulos = informacoesAutenticacao?.listaModulosPermitidos;
    var modulo = route.data.modulo;

    if (listaModulos) {
      return this.funcaoTestarModulo(listaModulos, modulo);
    }
    else {
      return this._contaService._eventoLogin.pipe(map((ia: SaidaAutenticacao) => {
        listaModulos = ia?.listaModulosPermitidos;
        return this.funcaoTestarModulo(listaModulos, modulo);
      }));
    }
  }

  funcaoTestarModulo = (listaModulos: string[], modulo: string): boolean => {
    return true;
    if (modulo == 'mapasgeo') {
      return true;
    }
    else if (listaModulos?.find(m => m == "Sistema") != null) {
      return true;
    }
    else {
      var listaModulosPermitidos = modulo?.split(",");
      var encontrouModuloPossivel = listaModulos?.find(m1 => listaModulosPermitidos.find(m2 => m1 == m2)) != null;

      if (!encontrouModuloPossivel) {
        this.router.navigate(['/conta/login']);
      }

      return encontrouModuloPossivel;
    }
  }
}
